export const enum BARRIER_MODES {
    DISABLED = 0,
    ENABLED = 1,
    NOT_CONFIGURED = 2
}